<template>
  <v-hover>
    <v-row slot-scope="{ hover }" class="py-0">
      <v-col :class="equalFlexSize ? `md6` : `md4`" class="font-2 text-left py-0">
        {{ displayTitle }} <span class="float-right">:</span>
      </v-col>
      <v-col
        :class="equalFlexSize ? `md6` : `md8`"
        class=" text-left d-inline-flex py-0"
      >
        <div v-if="link">
          <a
            v-if="displayValue"
            :href="displayValue"
            class="text-left link blue--text"
            target="_blank"
          >
            {{ displayValue }}
          </a>
          <span v-else>
            N/A
          </span>
        </div>
        <div v-else class="text-left">
          {{ displayValue }}
        </div>
        <div v-if="editable && hover" class="text-right mx-2">
          <v-icon
            v-text="$getIcon('mdiPencil')"
            :size="16"
            class="pointer"
            @click="syncEdit()"
          >
          </v-icon>
        </div>
        <div v-if="deletable && hover" class="text-right">
          <v-icon
            v-text="$getIcon('mdiDelete')"
            :size="16"
            class="pointer"
            @click="syncDelete()"
          >
          </v-icon>
        </div>
      </v-col>
    </v-row>
  </v-hover>
</template>
<script>
export default {
  props: {
    displayData: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    },
    displayTitle: {
      type: String,
      required: true
    },
    displayValue: {
      type: [String, Boolean, Number, undefined],
      required: false,
      default() {
        return "N/A";
      }
    },
    equalFlexSize: {
      type: Boolean,
      default: false
    },
    link: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      syncEdit() {
        this.$emit("update:edit-form", true);
        this.$emit("update:data", this.displayData);
      },
      syncDelete() {
        this.$emit("update:data", this.displayData);
        this.$emit("update:delete", true);
      }
    };
  }
};
</script>
